__turbopack_context__.v({
  "logo": "logo-module-scss-module__uyVP1q__logo",
});
